

import React, { useState, useRef, useEffect, useContext } from 'react';
import { Form, Input, Button, message, Spin, Space, Modal, Calendar } from 'antd';
import Style from './VipPage.module.css'
import axios from 'axios';

export default function VipPage(props) {
    const [payInfo, setPayInfo] = useState({
        total: 0,
        days: 0,
        standardPrice: 0,
        discountPrice: 0,
        discount: 0.85,
    })
    const [payImg, setPayImg] = useState('')

    const onPanelChange = (value, mode) => {
        console.log(value.format('YYYY-MM-DD'), mode);

    };
    useEffect(()=>{
        getList()
    },[])

    function getList() {
        axios({
            method: 'get',
            url: 'http://172.16.10.227:6801/pay/unitorderquery'
        }).then(res => {
            console.log('getlist', res)
        }).catch(err => { })
    }
    const onSelect = (newValue) => {
        // 定义目标日期（2026-01-11）
        const targetDate = new Date(newValue); // 注意：月份是从0开始计数的，所以1月用0表示
        // 获取今天的日期
        const today = new Date();
        // 计算两个日期之间的时间差（以毫秒为单位）
        const diffInMs = targetDate - today;
        // 将时间差转换为天数
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        console.log(`从今天到2026-01-11还有 ${diffInDays} 天`);
        let discount = (diffInDays * 100) * 0.15
        let total = diffInDays * 100 * payInfo.discount
        // 获取二维码
        axios({
            method: 'post',
            url: 'http://172.16.10.227:6801/pay/unitorderpay',
            data: {
                "trxAmtYuan": total,
                "payType": "W01",
                "body": "学费"
            }
        }).then(res => {
            console.log('res.r', res)
            if (res.data && res.data.data) {
                let resData = res.data.data
                setPayImg('http://172.16.10.227:2048/' + resData.qrCodePath)
            }
            setPayInfo({
                days: diffInDays,
                standardPrice: diffInDays * 100,
                discount: payInfo.discount,
                discountPrice: (diffInDays * 100 * (1 - payInfo.discount)).toFixed(2),
                total: total,
            })
        }).catch(err => {

        })

    };
    return (
        <div className={Style.mainDiv}>
            <div id="checkout_counter_popup" data-fc="1">
                <div className={Style.cc_main_info}>
                    <div className={Style.cc_main_header}>
                        <div id="ccmh_member_info">
                            <img src="https://gw.alicdn.com/tfs/TB1sSzsFG61gK0jSZFlXXXDKFXa-108-108.png" alt='' />
                            <div className={Style.cchmhi_info}>
                                <p>
                                    <span className={Style.cchmhi_name}>admin</span>
                                </p>
                                <p>
                                    <span className={Style.cchmhi_desc}>购买后享受会员权益，火点精度更加准确，推送时间更久</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="cc_detail_container" className={Style.cc_container}>
                        <div className={Style.cc_container_top}>
                            共{payInfo.days}天，&nbsp;
                            原价：<span className={Style.ccp_standardPrice}>￥{payInfo.standardPrice}</span>，&nbsp;&nbsp;
                            现价：￥{payInfo.total},
                            <span className={Style.ccp_item_badge}>特惠{payInfo.discount * 100}折</span>
                        </div>
                        <Calendar onPanelChange={onPanelChange} onSelect={onSelect} fullscreen={false} size='small' />
                    </div>
                </div>
                <div className={Style.cc_pay_container}>
                    <div id="cc_arrow" className={Style.cc_arrow}></div>
                    <div id="ccpw_form_main">
                        <div className={Style.ccpwm_price}>
                            <span>支付</span>
                            <span>¥</span>
                            <span>{payInfo.total}</span>
                        </div>
                        <div className={Style.ccpwm_qrcode_bg} data-code="0">
                            <img src={payImg} alt='' />
                            <span className={Style.scan_cover}></span>
                        </div>
                        <p className={Style.ccpwm_pay_desc}><span>支持</span>
                            <img src="https://gw.alicdn.com/tfs/TB1WZo_cCslXu8jSZFuXXXg7FXa-72-72.png" alt='' />
                            <img src="https://gw.alicdn.com/tfs/TB1gJYBeAL0gK0jSZFtXXXQCXXa-58-58.png" alt='' />
                            <span>扫码支付</span>
                        </p>
                        <div className={Style.ccwm_agreement}>开通前请阅读
                            <a href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_unification/suit_bu1_unification202111231337_81318.html" data-fcdom="agreement_0" target="_blank">《星科瑞升系列会员服务协议》</a>
                            <a href="https://render.alipay.com/p/f/fd-jcewajz2/index.html?spm=a2h09.8166731/c_UC_HOME.vip.1" data-fcdom="agreement_1" target="_blank">《付款授权服务协议》</a></div>
                    </div>
                </div>
                <div className={Style.cc_popup_window_close} data-fcdom="close"></div>
            </div>
        </div >
    )
}
